import { giphyBlack, giphyLightestGrey } from '@giphy/colors'
import { uniqueId } from 'lodash'
import { useRef } from 'react'
import { ControlSize } from 'types'
import { IconButton, PortalTooltip, useTooltip } from 'ui'
import { RecentsButtonOptions, RecentsTooltipOptions, UsernameData } from '../types'
import { Active, Avatar, Recent, Recents, Username, Verified } from './style'

type Props = {
    buttonOptions?: Partial<RecentsButtonOptions>
    className?: string
    recents: UsernameData[]
    size: ControlSize
    tooltipOptions?: Partial<RecentsTooltipOptions>
    username?: string
    onRecentClick?: (username: string) => void
}

const UsernameFieldRecents = ({
    buttonOptions = {},
    className,
    recents,
    size,
    tooltipOptions = {},
    username: activeUsername,
    onRecentClick,
}: Props) => {
    const idRef = useRef<string>(uniqueId('username-field-recents'))

    const { isOpen, listeners, closeTooltip, setNodeRef } = useTooltip({
        color: giphyBlack,
        direction: 'down',
        width: 500,
        id: idRef.current,
        ...tooltipOptions,
    })

    function onClick(username: string) {
        closeTooltip()
        onRecentClick?.(username)
    }

    return (
        <>
            <IconButton
                {...listeners}
                icon="navigate-down"
                iconColor={giphyLightestGrey}
                className={className}
                ref={setNodeRef}
                size={size}
                {...buttonOptions}
            />
            <PortalTooltip isOpen={isOpen}>
                <Recents>
                    {recents.map(({ avatar, username, verified }) => (
                        <Recent
                            $size="small"
                            key={`username-field-recent-${username}`}
                            onClick={() => onClick(username)}
                        >
                            <Avatar source={avatar} size="small" />
                            <Username>@{username}</Username>
                            {verified && <Verified />}
                            {username === activeUsername && <Active>Current</Active>}
                        </Recent>
                    ))}
                </Recents>
            </PortalTooltip>
        </>
    )
}

export default UsernameFieldRecents
